import eventConfig from "../../baseConfig/eventConfig";

const state = () => ({
    isLogin: false,
    payMoney:0,
    payStamp:0,
    realUser: {
        id: 0,
        userName: "",
        nickname: "",
        email: "",
        avatar: "",
        chip: 0,
        coin: 0,
        level: 1,
        newMsgNum: 0,
        bindAgent: "0",
        facebookId: null,
        bindPhone: false,
        everDeposit: false,
        timeStamp: 0,
        token: "",
        secretKey: "",
        lang: 'en',
        bgm: 0,
        sfx: 0,
        notice: 0,
        channel:""
    },
    guestUser: {} 
    /**
     *  stamp:0
        token: "",
        secretKey: "",
     * 
     */

})

// getters
const getters = {
    getGuest:(state) => (country) => {
        if (!state.guestUser[country]) {
            return null;
        }
        return state.guestUser[country];
    },
    getPayMoney:state => {
        return state.payMoney;
    },
    getMoney:state => {
        if (!state.isLogin || !state.realUser.id) {
            return eventConfig.NO_LOGIN_FLAG;
        }
        return state.realUser.chip;
    }
}

// actions
const actions = {

}

// mutations
const mutations = {
    setGuestAccount(state , data){
        let item = {
            stamp: Math.floor((new Date()).getTime() / 1000),
            secretKey: data.secretKey,
            token: data.token
        }
        let country = data.country;
        !country && (country = "in");
        state.guestUser[country] = item;
    },
    setMoney(state , money){
        state.realUser.chip = money;
    },
    setUserData(state, data) {
        /**
       *
       * accountType: 1
    avatar: "http://slots-static.bangbet.com/avatar.jpg"
    bestWin: 0
    bestWinFlag: ""
    bigWinNum: 0
    bindAgent: "0"
    birthday: null
    bonus: 0
    bvn: null
    bvnResponse: null
    bvnVerified: false
    channel: "UCWVVSYS"
    chip: 0
    coin: 0
    country: "in"
    email: "15539353523@163.com"
    everDeposit: false
    exp: 0
    facebookId: null
    firstName: null
    firstRechargeInfo: "{"amount":0,"bonus":0.0,"firstRecharge":false,"markedPrice":0.0,"realPrice":0.0}"
    gender: null
    id: 3136032
    lastName: null
    level: 0
    newMsgNum: 0
    nickname: "15539353523"
    noviciate: 0
    passwordSet: true
    platformModeType: 3
    regitstTime: 1605525341661
    superWinNum: 0
    totalReward: 0
    totalRound: 0
    unlockGameArr: null
    userId: 0
    userName: null
    bgm：背景音乐参数
    sfx：音效参数
    notice：提示参数
       * */
        state.realUser.id = data.id;
        state.realUser.userName = data.userName;
        state.realUser.nickname = data.nickname;
        state.realUser.email = data.email;

        state.realUser.avatar = data.avatar;
        state.realUser.chip = data.chip;
        state.realUser.level = data.level;
        state.realUser.newMsgNum = data.newMsgNum;
        state.realUser.bindAgent = data.bindAgent;

        state.realUser.everDeposit = data.everDeposit;

        state.realUser.facebookId = data.facebookId;

        state.realUser.lang = data.language;

        state.realUser.bgm = data.bgm;
        state.realUser.sfx = data.sfx;
        state.realUser.notice = data.notice;
        state.realUser.channel= data.channel;

        // state.realUser.bindAgent = data.bindAgent;


    },
    setToken(state, data) {
        console.log(state);
        state.realUser.id = data.userId;
        state.realUser.token = data.token;
        state.realUser.secretKey = data.secretKey;
        state.isLogin = true;

    },
    setPayMoney(state , money){
        state.payMoney = money;
        state.payStamp = Math.floor((new Date()).getTime() / 1000);
    },
    clearLogin(state) {
        state.isLogin = false;
        state.realUser = {
            id: 0,
            userName: "",
            nickname: "",
            email: "",
            avatar: "",
            chip: 0,
            coin: 0,
            level: 1,
            newMsgNum: 0,
            bindAgent: "0",
            facebookId: null,
            bindPhone: false,
            everDeposit: false,
            timeStamp: 0,
            token: "",
            secretKey: "",
        }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js